// extracted by mini-css-extract-plugin
export var scrollArea = "_pr-0";